export const roleDistributionErrorTypes = [
    'totalPercentageNot100',
    'percentageHigherThan0',
    'percentageRequired',
] as const;

export type ServiceOrganizationRoleDistributionsErrors = Map<(typeof roleDistributionErrorTypes)[number], string>;
